import type { EarningsRow } from '../types/earnings';

/**
 * Total cents a chef has earned across their earnings feed.
 *
 * Sums `snapshot.grossCents` over every row that actually earned money.
 * Cancelled rows carry no snapshot (nothing was captured, so no gross) and
 * fall out for free; `captured-partial` carries the cancellation fee as its
 * gross and IS counted — that fee is real earnings.
 *
 * Shared by the My Earnings header and the profile-menu sub line so the two
 * surfaces can never quote different figures. Until the payouts flow ships,
 * nothing has been paid out, which makes this same number the chef's unpaid
 * balance; when payouts land, the menu's figure is what has to change.
 */
export function sumEarnedCents(rows: EarningsRow[] | undefined): number {
  return (rows ?? []).reduce(
    (sum, r) => sum + (r.snapshot?.grossCents ?? 0),
    0,
  );
}
